import { observer } from "mobx-react-lite";
import { useStore } from "../../../app/stores/store";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Grid, Loader, Message, Table } from "semantic-ui-react";
import SysAdminSidebar from "../SysAdminSidebar";
import PageHeader from "../../../app/layout/PageHeader";
import { format } from "date-fns";
import { LogLevel } from "../../../app/models/client";

export default observer(function ViewClient() {
  const { t } = useTranslation(["common", "systemAdmin"]);
  const { id } = useParams<{ id: string }>();
  const [loading, setLoading] = useState<boolean>(true);

  const { clientSystemAdminStore } = useStore();

  const getClassName = (l: LogLevel) => {
    switch (l) {
      case LogLevel.Warning:
        return "warning";
      case LogLevel.Critical:
        return "error";
      default:
        return undefined;
    }
  };

  const {
    loadImportLogs,
    ClientImportLogs,
    loadClientInformation,
    selectedSystemAdminClientDetails,
  } = clientSystemAdminStore;

  useEffect(() => {
    async function fetchData() {
      setLoading(true);

      await loadClientInformation(id as string);
      await loadImportLogs(id as string);

      setLoading(false);
    }

    fetchData();
  }, [loadImportLogs, loadClientInformation, id]);

  if (loading) {
    return <Loader />;
  }

  return (
    <Grid stackable>
      <Grid.Row>
        <Grid.Column width={3}>
          <SysAdminSidebar />
        </Grid.Column>
        <Grid.Column width={13}>
          <Grid.Row columns={1}>
            <Grid.Column>
              <PageHeader
                type="h1"
                header={`Import Logs: ${selectedSystemAdminClientDetails?.name}`}
                className="modal-text-color"
                textAlign="left"
                divider
                addTitle
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Table celled>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Event Date</Table.HeaderCell>
                    <Table.HeaderCell>Event</Table.HeaderCell>
                    <Table.HeaderCell>Level</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {ClientImportLogs?.length > 0 ? (
                    ClientImportLogs.map((x) => (
                      <Table.Row
                        key={`logs.${x.id}`}
                        className={getClassName(x.level)}
                      >
                        <Table.Cell>
                          {x.createdDate && format(x.createdDate, "P p")}
                        </Table.Cell>
                        <Table.Cell>{x.event}</Table.Cell>
                        <Table.Cell>{LogLevel[x.level]}</Table.Cell>
                      </Table.Row>
                    ))
                  ) : (
                    <Table.Row key={"noItems"}>
                      <Table.Cell width="8" colSpan={8}>
                        <Message
                          color="yellow"
                          className="textAlignCenter fontStyleItalic"
                        >
                          {t("grid_noItems", { ns: "common" })}
                        </Message>
                      </Table.Cell>
                    </Table.Row>
                  )}
                </Table.Body>
              </Table>
            </Grid.Column>
          </Grid.Row>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
});
